import React from 'react';
import { View } from '@aws-amplify/ui-react';

// Header is now empty chrome — Create Design lives on the Designs page,
// user/account menu and color-mode toggle live at the bottom of the sidebar.
// Kept as a no-content row so the Layout grid template still has a row-1 cell
// (callers gate on `baseConfig.header`; flipping that to false is the right
// follow-up if no future surface needs the slot).
const Header = () => {
  return <View height="0" />;
};

export default Header;
